var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProductHeader',{attrs:{"supplier-id":_vm.supplierId,"supplier-type":_vm.supplierType,"supplier-name":_vm.supplierName,"productId":_vm.productId,"productName":_vm.productName,"productType":_vm.productType}}),_c('v-container',{staticClass:"justify-center",attrs:{"fluid":"","fill-height":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }